<template>
  <div class="px-2 py-4 sm:px-4 sm:py-6">
    <!-- Tab Navigation -->
    <div
      class="border-b border-gray-200 dark:border-gray-700 mb-4 sm:mb-6 -mx-2 px-2 sm:mx-0 sm:px-0"
    >
      <nav class="-mb-px flex space-x-2 sm:space-x-6 flex-wrap">
        <button
          @click="activeTab = 'users'"
          :class="[
            activeTab === 'users'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
            'whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm'
          ]"
        >
          Gebruikers
        </button>
        <button
          @click="activeTab = 'database'"
          :class="[
            activeTab === 'database'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
            'whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm'
          ]"
        >
          Database
        </button>
        <button
          @click="activeTab = 'top20'"
          :class="[
            activeTab === 'top20'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
            'whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm'
          ]"
        >
          Top Accounts
        </button>
        <button
          @click="activeTab = 'sync'"
          :class="[
            activeTab === 'sync'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
            'whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm'
          ]"
        >
          Synchronisatie
        </button>
        <button
          @click="activeTab = 'teams'"
          :class="[
            activeTab === 'teams'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
            'whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm relative'
          ]"
        >
          Teams
          <span
            v-if="teamsWithoutPLCount > 0"
            class="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] font-bold rounded-full h-4 min-w-[16px] flex items-center justify-center px-1"
          >
            {{ teamsWithoutPLCount }}
          </span>
        </button>
        <button
          @click="activeTab = 'budget'"
          :class="[
            activeTab === 'budget'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
            'whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm'
          ]"
        >
          Begroting
        </button>
        <button
          @click="activeTab = 'fteBudget'"
          :class="[
            activeTab === 'fteBudget'
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600',
            'whitespace-nowrap py-3 sm:py-4 px-1 border-b-2 font-medium text-sm'
          ]"
        >
          FTE-doelstellingen
        </button>
      </nav>
    </div>

    <!-- Tab Content -->
    <AdminUsersTab v-show="activeTab === 'users'" />
    <AdminDatabaseTab v-show="activeTab === 'database'" :is-active="activeTab === 'database'" />
    <AdminTop20Tab v-show="activeTab === 'top20'" />
    <AdminSyncTab v-if="activeTab === 'sync'" />
    <AdminTeamsTab v-show="activeTab === 'teams'" />
    <AdminBudgetTab v-show="activeTab === 'budget'" />
    <AdminFteBudgetTab v-show="activeTab === 'fteBudget'" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { adminService } from '@/services/adminService.js'

import AdminUsersTab from '@/components/admin/AdminUsersTab.vue'
import AdminDatabaseTab from '@/components/admin/AdminDatabaseTab.vue'
import AdminTop20Tab from '@/components/admin/AdminTop20Tab.vue'
import AdminSyncTab from '@/components/admin/AdminSyncTab.vue'
import AdminTeamsTab from '@/components/admin/AdminTeamsTab.vue'
import AdminBudgetTab from '@/components/admin/AdminBudgetTab.vue'
import AdminFteBudgetTab from '@/components/admin/AdminFteBudgetTab.vue'

// Tab state
const activeTab = ref('users')

// Lightweight query for Teams badge count (always active)
const { data: teamPLData } = useQuery({
  queryKey: ['team-pl-overview'],
  queryFn: () => adminService.getTeamPLOverview(),
  staleTime: 1000 * 60 * 5
})

const teamsWithoutPLCount = computed(
  () => (teamPLData.value || []).filter(t => t.performance_leads.length === 0).length
)
</script>
